export const USER_LOCALE_COOKIE_NAME = 'userLocale';
